import styled from 'styled-components';

export const TitleStyles = styled.section`
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  .btn-remove-all-data {
    margin-bottom: 24px;
  }
`;
